var render, staticRenderFns
import script from "./ResizableCard.vue?vue&type=script&lang=js"
export * from "./ResizableCard.vue?vue&type=script&lang=js"
import style0 from "./ResizableCard.vue?vue&type=style&index=0&id=f04e7800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports